import React, { useContext } from 'react';

import TrackingContext from '../contexts/TrackingContext';

type EventTrackingPageProps = {
  pageGroup: string;
  page: string;
};

const EventTrackingPage: React.FC<EventTrackingPageProps> = ({
  pageGroup,
  page,
  children,
}) => {
  const trackingContext = useContext(TrackingContext);

  if (!trackingContext.applicationName) {
    throw new Error(
      `<EventTrackingPage pageGroup="${pageGroup}" page="${page}"> must be used within a <EventTrackingApp> component`,
    );
  }

  return (
    <TrackingContext.Provider value={{ ...trackingContext, pageGroup, page }}>
      {children}
    </TrackingContext.Provider>
  );
};

export default EventTrackingPage;
